import { Subject, from } from 'rxjs';

const subject = new Subject();

export default subject;